// extracted by mini-css-extract-plugin
export default {"rating":"TB-z","numberOfStars":"UB-z","count":"VB-z","barGraphSpacing":"WB-z","barGraph":"XB-z"};